export const DEFAULTPATH = '/prodSchedule'
window.DEFAULTPATH = DEFAULTPATH
export function getDefaultData() {
  return DEFAULTPATH
}
